<template>
  <div>
    <md-table class="channel-sessions">
      <md-table-row>
        <md-table-cell>Channel ID</md-table-cell>
        <md-table-cell>User Count</md-table-cell>
        <md-table-cell>Device Count</md-table-cell>
        <md-table-cell>Client Count</md-table-cell>
        <md-table-cell>Connection Count</md-table-cell>
      </md-table-row>
    </md-table>
    <!-- empty case -->
    <md-table
      class="table-striped table-hover channel-sessions"
      v-if="!channelSessions || !channelSessions.length"
    >
      <md-table-row slot="md-table-row">
        <md-table-cell :colspan="5"
          >You have no active channels right now.</md-table-cell
        >
      </md-table-row>
    </md-table>
    <!-- non-empty case -->
    <md-table
      class="table-striped table-hover channel-sessions data"
      v-for="(channel, index) in channelSessions"
      :key="index"
    >
      <md-table-row
        slot="md-table-row"
        v-on:click="getChildren('clientStats', 'active_clients', channel)"
        :key="sessionKey"
      >
        <md-table-cell
          :data-tour="index == 0 ? 'connection_stats_channel_id_live' : false"
          >{{ channel.id }}</md-table-cell
        >
        <md-table-cell>{{ channel.userCount }}</md-table-cell>
        <md-table-cell>{{ channel.deviceCount }}</md-table-cell>
        <md-table-cell>{{ channel.clientCount }}</md-table-cell>
        <md-table-cell>{{ channel.connectionCount }}</md-table-cell>
      </md-table-row>
      <md-table-row v-if="channel.showChildren">
        <md-table-cell :colspan="5">
          <md-table class="client-sessions">
            <md-table-row>
              <md-table-cell>Client ID</md-table-cell>
              <md-table-cell>User ID</md-table-cell>
              <md-table-cell>Device ID</md-table-cell>
              <md-table-cell>Connection Count</md-table-cell>
            </md-table-row>
          </md-table>
          <md-table
            v-for="(client, index) in channel.children"
            :key="client.id"
            class="table-striped table-hover client-sessions data"
          >
            <md-table-row
              slot="md-table-row"
              @click="
                getChildren(
                  'connectionStats',
                  'active_connections',
                  client,
                  channel.id
                )
              "
            >
              <md-table-cell
                :data-tour="
                  index == 0 ? 'connection_stats_client_id_live' : false
                "
                >{{ client.id }}</md-table-cell
              >
              <md-table-cell>{{ client.userId }}</md-table-cell>
              <md-table-cell>{{ client.deviceId }}</md-table-cell>
              <md-table-cell>{{ client.connectionCount }}</md-table-cell>
            </md-table-row>
            <md-table-row v-if="client.showChildren">
              <md-table-cell :colspan="4">
                <md-table class="connection_stats">
                  <md-table-row>
                    <md-table-cell>Connection ID</md-table-cell>
                    <md-table-cell>User Id</md-table-cell>
                    <md-table-cell>Device ID</md-table-cell>
                    <md-table-cell>Client ID</md-table-cell>
                  </md-table-row>
                </md-table>
                <md-table
                  class="table-striped table-hover connection_stats data"
                  v-for="(connection, index) in client.children"
                  :key="connection.id"
                >
                  <md-table-row
                    slot="md-table-row"
                    @click="routeToConnection(connection.id)"
                  >
                    <md-table-cell
                      :data-tour="
                        index == 0
                          ? 'connection_stats_connection_id_live'
                          : false
                      "
                      >{{ connection.id }}</md-table-cell
                    >
                    <md-table-cell>{{ connection.userId }}</md-table-cell>
                    <md-table-cell>{{ connection.deviceId }}</md-table-cell>
                    <md-table-cell>{{ connection.clientId }}</md-table-cell>
                  </md-table-row>
                </md-table>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>
<script>
import { get } from "vuex-pathify";
export default {
  computed: {
    channelSessions: get("channelStats/entities")
  },
  data: () => ({
    appId: "-",
    sessionKey: 0
  }),
  methods: {
    loadChannelStats: function(applicationId) {
      var me = this;
      this.appId = applicationId;
      this.$store
        .dispatch("channelStats/loadEntities", [
          { k: "tag", v: "active_channels" },
          { k: "applicationId", v: me.appId }]
        )
        .then(() => {
          for (var i = 0; i < me.channelSessions.length; i++) {
            me.channelSessions[i].showChildren = false;
            me.channelSessions[i].children = [];
          }
        })
        .catch(() => {
          /* TODO: Should we do something here? */
        });
    },
    getChildren: function(endpoint, tag, item, channelId) {
      var me = this;
      if (item.children.length === 0) {
        var extra = [{ k: "tag", v: tag }, { k: "applicationId", v: me.appId }];
        if (endpoint === "clientStats") {
          //add extra info that needs to be sent to the endpoint
          extra.push({ k: "channelId", v: item.id });
        } else {
          extra.push({ k: "channelId", v: channelId });
          extra.push({ k: "clientId", v: item.id });
        }
        this.$store
          .dispatch(endpoint + "/loadEntities", extra)
          .then(() => {
            item.children = me.$store.get(endpoint + "/entities");

            for (var i = item.children.length - 1; i >= 0; i--) {
              item.children[i].showChildren = false;
              item.children[i].children = [];
              // Connections are not filtered by client in the v1 API ultimately called to handle this query.
              // There is no API that can do this, so we use one that gives all connections per App and Channel,
              // and then we filter the clients that do not belong here.
              if (
                endpoint === "connectionStats" &&
                item.id !== item.children[i].clientId
              ) {
                item.children.splice(i, 1);
              }
            }
            item.showChildren = item.children.length > 0;
            me.bumpKey();
          })
          .catch(() => {
            /* TODO: Should we do something here? */
          });
      } else {
        item.showChildren = !item.showChildren;
        me.bumpKey();
      }
    },
    bumpKey: function() {
      this.sessionKey++;
    },
    routeToConnection: function(id) {
      this.$router.push({
        path: `/connectionstats/${id}`,
        query: { applicationId: this.appId }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ table {
  table-layout: fixed;
  width: 100%;
}
div.channel-sessions table td {
  width: 25%;
}
div.client-sessions table td {
  width: 33%;
}
div.connection_stats table td {
  width: 25%;
}
.md-table.data .md-table-row {
  cursor: pointer;
}
/deep/ .md-table-cell:last-child .md-table-cell-container {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
